import moment from "moment/moment";
import React, { useState } from "react";
import { Row } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { editIcon, viewIcon } from "../../assets/img";

const Transaction = ({
  getTransaction,
  setTransactionPage,
  paginationTransaction,
  transactionCount,
  transactionRow,
  transactions,
  transactionBalance,
}) => {
  const navigate = useNavigate();

  const handlePageChange = (selectedObject) => {
    setTransactionPage(selectedObject.selected + 1);
  };
  return (
    <div>
      {" "}
      <Row md={12} sm={12} lg={12}>
        <div className="col-md-6 mt-5">
          <label className="table-labels f1">
            Total Count : {paginationTransaction?.total}
          </label>
        </div>
      </Row>
      <div className="d-flex ac-jb ">
        <div className="col-md-2 p-0">
          <select
            className="form-control custom-select"
            onChange={(e) => getTransaction(e.target.value)}
            value={transactionRow}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
      <div className="table-custom-design overflow-scroll">
        <table>
          <thead className="single-book-table">
            <tr className="text-capitalize text-nowrap">
              <th>S.NO</th>
              <th>Date</th>
              <th>Type</th>
              <th>Booking ID</th>
              <th>Transaction type</th>
              <th>Transaction Amount</th>
              <th>Balance Amount (₹)</th>
            </tr>
          </thead>
          <tbody>
            {transactions?.map((item, ind) => {
              return (
                <tr key={ind}>
                  <td>
                    {(paginationTransaction?.current_page - 1) *
                      transactionRow +
                      ind +
                      1}
                  </td>
                  <td>{moment(item?.created_at).format("DD-MM-YYYY")}</td>
                  <td>{item?.type}</td>
                  <td>
                    {" "}
                    <button
                      className="link-btn"
                      onClick={() =>
                        navigate("/booked-rooms-view", {
                          state: { data: item },
                        })
                      }
                    >
                      {item?.booking_id}
                    </button>
                  </td>
                  <td>{item?.display_type}</td>
                  <td>{item?.total_amount}</td>
                  <td>{transactionBalance?.[ind]?.balance}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="page-inner-cont py-2 d-flex justify-content-end">
        <ReactPaginate
          nextLabel="››"
          onPageChange={handlePageChange}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          pageCount={transactionCount}
          previousLabel="‹‹"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default Transaction;
